import { PageItemApi } from 'api/PageItemApi';
import { PageItemKindMapper } from 'mapper/PageItemMapper';
import { QuestionAbstractMapper } from 'mapper/QuestionAbstractMapper';
import { PageItemModel } from 'api/dto/PageItem.dto';
import { PageItemKind } from 'model/PageItemKind';
import { QuestionRadio } from 'model/QuestionRadio';

export class QuestionRadioMapper
  implements PageItemKindMapper<QuestionRadio, PageItemApi.QuestionRadioEntry>
{
  constructor() {}

  serialize(model: QuestionRadio): PageItemApi.QuestionRadioEntry {
    return {
      ...QuestionAbstractMapper.serialize(model),
      options: model.options,
      required: model.isRequired ? 1 : 0,
      hasOther: model.hasOther ? 1 : 0,
    };
  }

  deserialize(entry: PageItemApi.QuestionRadioEntry): QuestionRadio {
    return {
      ...QuestionAbstractMapper.deserializeShape(entry),
      options: (entry.options || []).sort((a, b) => a.position - b.position),
      isRequired: Boolean(entry.required),
      hasOther: Boolean(entry.hasOther),
    };
  }

  supportsSerialize(model: PageItemModel): boolean {
    return model.kind === PageItemKind.QuestionRadioButton;
  }

  supportsDeserialize(entry: PageItemApi.ImageWidgetEntry): boolean {
    return entry.kind === PageItemKind.QuestionRadioButton;
  }
}
